'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { visitorTrackingService } from '@/app/service/visitorTracking/visitorTrackingService';

export default function VisitorTracker() {
    const trackTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const previousPathRef = useRef<string | null>(null);
    const isInitialRef = useRef(true);
    const pathname = usePathname();

    useEffect(() => {
        // Track visitor page view
        const trackVisit = async (isFirstVisit: boolean) => {
            try {
                await visitorTrackingService.trackVisitor({
                    page: pathname,
                    // U3-1: 유입 경로는 최초 진입 시 1회만 기록한다(내부 라우트 이동 시 리퍼러가 자기 자신으로 덮이는 것을 방지)
                    ...(isFirstVisit ? { referrer: `${document.referrer || ''}${window.location.search || ''}` || undefined } : {}),
                });
            } catch (error) {
                // Silently fail
            }
        };

        // Track on page/route change
        if (isInitialRef.current) {
            // First load - delay to allow auth middleware to restore token
            isInitialRef.current = false;
            previousPathRef.current = pathname;
            setTimeout(() => {
                trackVisit(true);
            }, 2000);
        } else if (previousPathRef.current !== pathname) {
            // Route changed - track new page
            previousPathRef.current = pathname;
            trackVisit(false);
        }
    }, [pathname]);

    return null;
}
